import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br to-indigo-600 flex items-center justify-center p-4">
      <div className="max-w-lg w-full text-center bg-white rounded-xl shadow-2xl p-8 md:p-12">
        <h1 className="text-9xl font-bold text-customBlue mb-4 animate-bounce">404</h1>
        <h2 className="text-3xl font-bold text-gray-800 mb-4">Oops! Page Not Found</h2>
        <p className="text-gray-600 mb-8">
          The page you're looking for might have been removed, had its name changed,
          or is temporarily unavailable.
        </p>
        <button
          onClick={() => navigate('/')}
          className="inline-block px-8 py-3 text-lg font-medium text-white bg-customBlue rounded-lg hover:bg-blue-700 transition-all duration-300 transform hover:scale-105"
        >
          Back to Home
        </button>
        <div className="mt-8 animate-pulse">
          <svg 
            className="w-24 h-24 mx-auto text-blue-500" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth="2" 
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default NotFound;